import React from "react";

import {
    Backdrop,
    Box,
    Button,
    Stack,
    Typography
} from "@mui/material";
import { Trans } from "@lingui/macro";
import { ShoppingCart } from "@mui/icons-material";

export default class PaywallModal extends React.Component<{ buyCallbackFn: () => void }, {}> {

    render() {
        return (<Backdrop
            sx={{
                color: "#FFFFFF",
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}
            open={true}>
            <Box
                style={{
                    border: "2px solid " + process.env.REACT_APP_SECONDARY_COLOR,
                    minWidth: "350px",
                    minHeight: "200px",
                    padding: "25px",
                    textAlign: "center",
                    position: "fixed",
                    bottom: "50%"
                }}>
                <Stack spacing={1}>
                    <Typography variant="h2" color={process.env.REACT_APP_PRIMARY_COLOR}>
                        <Trans id="pm-modal-title">
                            Contenuto a pagamento
                        </Trans>
                    </Typography>
                    <Typography variant="body1" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                        <Trans id="pm-modal-text">
                            Per visionare il contenuto devi acquistare il ticket digitale
                        </Trans>
                    </Typography>
                    <Button variant="outlined" startIcon={<ShoppingCart />} onClick={() => this.props.buyCallbackFn()}>
                        <Trans id="pm-modal-buy">
                            Compra
                        </Trans>
                    </Button>
                </Stack>
            </Box>

        </Backdrop>);
    }
}
